/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".property-search-label[_ngcontent-%COMP%]{color:gray!important;font-size:10pt!important}.property-search-values[_ngcontent-%COMP%]{font-weight:700!important;font-size:10pt!important}"];
export { styles as styles };
